<template>
  <div class="pentagon-divider">
    <span class="pentagon-divider__rule" aria-hidden="true"></span>
    <h2 :class="`pentagon-banner pentagon-${variant}`" class="h1 pentagon-divider__title">
      {{ title }}
    </h2>
    <span class="pentagon-divider__rule" aria-hidden="true"></span>
  </div>
</template>

<script>
export default {
  name: 'SectionDivider',
  props: {
    title: {
      type: String,
      required: true,
    },
    variant: {
      type: String,
      default: 'crimson',
      validator: value => ['crimson', 'forest'].indexOf(value) !== -1,
    },
  },
};
</script>

<style>
  .pentagon-divider {
    display: flex;
    align-items: center;
    margin: 2.5rem 0 1rem;
  }

  .pentagon-divider__title {
    flex: 0 1 auto;
    margin: 0 1rem;
    text-align: center;
  }

  .pentagon-divider__rule {
    flex: 1 1 1.5rem;
    height: 1px;
    background: linear-gradient(to right, rgba(255, 215, 0, 0), rgba(255, 215, 0, 0.45));
  }

  .pentagon-divider__rule:last-child {
    background: linear-gradient(to left, rgba(255, 215, 0, 0), rgba(255, 215, 0, 0.45));
  }

  @media (max-width: 575.98px) {
    .pentagon-divider__title {
      margin: 0 0.75rem;
      font-size: 1.2rem;
    }
  }
</style>
